import config from "@/config";
import { Box, Button, Card, CardContent, CardHeader, Container, Divider, Grid, Stack, Typography } from "@mui/material";
import { Link as RouterLink, useOutletContext } from "react-router-dom";

export function EditInfomationButton(props) {
    const { label, to } = props;
    return (
        <Button component={RouterLink} to={to}>
            {label}
        </Button>
    );
}

export function Section(props) {
    const { title, description, action, children, sx } = props;

    return (
        <Box sx={{ width: "100%", paddingY: 3, ...sx }}>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box sx={{ flexGrow: 1, marginRight: "auto" }}>
                    <Typography variant="h5">{title}</Typography>
                    <Typography variant="body" color="grey">
                        {description}
                    </Typography>
                </Box>
                <Box>{action}</Box>
            </Box>
            <Box sx={{ marginTop: 3 }}>{children}</Box>
        </Box>
    );
}

export default function Information() {
    const { project } = useOutletContext();
    const settingUrl = (hash) => `/projects/${project?.id}/settings/info#${hash}`;

    return (
        <Container sx={{ marginTop: 3 }}>
            <Grid container sx={{ columnGap: 3 }}>
                <Grid item xs>
                    <Card variant="outlined">
                        <CardHeader title="Information"></CardHeader>
                        <Divider variant="middle" />
                        <CardContent sx={{ paddin: 2 }}>
                            <Stack>
                                <Section
                                    title="Abstract"
                                    description="abstract"
                                    // action={<EditInfomationButton label="Edit" to={settingUrl("abstract")} />}
                                >
                                    <Box
                                        compoment="pre"
                                        sx={{
                                            textWrap: "wrap",
                                            whiteSpace: "break-spaces",
                                        }}
                                    >
                                        {project?.abstract}
                                    </Box>
                                </Section>
                                <Section
                                    title="Objective"
                                    description="objective"
                                    // action={<EditInfomationButton label="Edit" to={settingUrl("objective")} />}
                                >
                                    <Box
                                        compoment="pre"
                                        sx={{
                                            textWrap: "wrap",
                                            whiteSpace: "break-spaces",
                                        }}
                                    >
                                        {project?.objective}
                                    </Box>
                                </Section>
                                <Section
                                    title="Procedure"
                                    // action={<EditInfomationButton label="Edit" to={settingUrl("procedure")} />}
                                    description="procedure"
                                >
                                    <Box
                                        compoment="pre"
                                        sx={{
                                            textWrap: "wrap",
                                            whiteSpace: "break-spaces",
                                        }}
                                    >
                                        {project?.procedure}
                                    </Box>
                                </Section>
                                <Section
                                    title="Benefit"
                                    description="benefit"
                                    // action={<EditInfomationButton label="Edit" to={settingUrl("benefit")} />}
                                >
                                    <Box
                                        compoment="pre"
                                        sx={{
                                            textWrap: "wrap",
                                            whiteSpace: "break-spaces",
                                        }}
                                    >
                                        {project?.benefit}
                                    </Box>
                                </Section>
                                <Section
                                    title="Location"
                                    description="location"
                                    // action={<EditInfomationButton label="Edit" to={settingUrl("location")} />}
                                >
                                    <Box
                                        compoment="pre"
                                        sx={{
                                            textWrap: "wrap",
                                            whiteSpace: "break-spaces",
                                        }}
                                    >
                                        {project?.location}
                                    </Box>
                                </Section>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs="auto" sx={{ padding: 1 }}>
                    <Typography fontWeight="bold" gutterBottom>
                        About
                    </Typography>
                    <Box component="table" sx={{ color: "gray" }}>
                        <tbody>
                            <tr>
                                <td>Lifecycle status:</td>
                                <td>{project?.lifecycle_status?.name_display ?? "-"}</td>
                            </tr>
                            <tr>
                                <td>Achievement status:</td>
                                <td>{project?.achievement_status?.name_display ?? "-"}</td>
                            </tr>
                            <tr>
                                <td>Size:</td>
                                <td>{project?.size?.name_display ?? "-"}</td>
                            </tr>
                            <tr>
                                <td>Duration</td>
                                <td>{project?.duration?.name_display ?? "-"}</td>
                            </tr>
                            <tr>
                                <td>Flagship:</td>
                                <td>{project?.is_flagship ? "Yes" : "No"}</td>
                            </tr>
                            <tr>
                                <td>Members:</td>
                                <td>{project?.members_count ?? "-"}</td>
                            </tr>
                        </tbody>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
}
